import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d72974c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center heading step-heading step-heading-1" }, " Do you need a loan? Watch this video now. ", -1))
const _hoisted_3 = { class: "step-video" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "heading-2 step-heading-2" }, "Get Onboard in 4 Steps", -1))
const _hoisted_6 = { class: "step-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Download app from your application store.", -1))
const _hoisted_8 = {
  class: "d-flex flex-column align-items-center justify-content-center",
  style: {"transform":"translateY(10%)"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-box-3 d-flex align-items-center justify-content-center" }, " 1 ", -1))
const _hoisted_10 = { class: "step-box-1 d-flex align-items-center justify-content-center" }
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = { class: "step-box-2 d-flex align-items-center justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: require('@/assets/onVideos.png'),
        class: "w-100",
        alt: "videos "
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5,
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.dssClass)
    }, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.downloads, (download) => {
            return (_openBlock(), _createBlock(_component_Button, {
              key: download.head,
              iconed: "",
              icon: download.icon,
              head: download.head,
              foot: download.foot,
              onClick: _ctx.countdown
            }, null, 8, ["icon", "head", "foot", "onClick"]))
          }), 128))
        ]),
        _hoisted_9
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
        return (_openBlock(), _createElementBlock("div", {
          key: step.id,
          class: _normalizeClass(_ctx.dsClass)
        }, [
          _createElementVNode("p", null, _toDisplayString(step.text2), 1),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(), _createElementBlock("svg", null, [
              _createElementVNode("use", {
                "xlink:href": `${require('@/assets/icons.svg')}#icon-${step.icon}`
              }, null, 8, _hoisted_11)
            ])),
            _createTextVNode(_toDisplayString(step.text), 1)
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(step.id), 1)
        ], 2))
      }), 128))
    ], 2)
  ]))
}